<script lang="ts">
  import { getHref } from '../../helpers/sections-helper';
  import { BulletPoint } from '../../components/index';
  import type { Header } from '../types';
  import type { MktSettings } from 'customer-components/lib/types';
  export let properties: Header;
  export let settings: MktSettings;

  $: ({ button, icon, secondaryButton, secondaryIcon } = properties);
  $: ({ logo, businessName, menu } = settings);

  let menuOpen = false;

  function toggleMenu() {
    menuOpen = !menuOpen;
  }
</script>

<header class="bg-[--color-neutral-white,#fff]">
  <div class="container mx-auto flex items-center justify-between px-6 py-4">
    <!-- Logo -->
    <div class="flex items-center">
      {#if logo.value}
        <img
          class="logo h-14 flex-shrink-0 md:h-16"
          src={logo?.value}
          alt="logo"
        />
      {:else}
        <span class="text-left text-lg font-bold !text-[var(--color-primary)]"
          >{@html businessName}</span
        >
      {/if}
    </div>
    {#if menu?.active && menu?.links?.length > 0}
      <!-- Navigation links (desktop) -->
      <nav class="hidden space-x-8 lg:flex">
        {#each menu.links as link}
          <a href={link.value} class="text-gray-600 hover:text-black"
            >{@html link.label}</a
          >
        {/each}
      </nav>
    {/if}

    <!-- Buttons (text and call) -->
    <div class="flex space-x-2 sm:space-x-4">
      {#if secondaryButton?.active}
        <a
          class="flex items-center justify-center gap-2 rounded-[--border-4,4px] border-2 border-[--color-neutral-black] bg-[--color-neutral-white] px-[13px] py-[8px] font-semibold text-[--color-neutral-black]"
          href={getHref(secondaryButton.link_type, secondaryButton.link)}
        >
          {#if secondaryIcon?.active}
            <BulletPoint bulletIcon={secondaryIcon?.value} />
          {/if}
          <span class="hidden sm:block">{@html secondaryButton?.label}</span>
        </a>
      {/if}
      {#if button?.active}
        <a
          class="flex items-center justify-center gap-2 rounded-[--border-4,4px] bg-[--color-accent] px-[13px] py-[8px] font-medium text-[--color-neutral-white]"
          href={getHref(button.link_type, button.link)}
        >
          {#if icon?.active}
            <BulletPoint bulletIcon={icon?.value} />
          {/if}
          <span class="hidden sm:block">{@html button?.label}</span>
        </a>
      {/if}
      {#if menu?.active && menu?.links?.length > 0}
        <!-- Mobile menu button -->
        <button class="text-gray-600 lg:hidden" on:click={toggleMenu}>
          {#if !menuOpen}
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.75 20.9312C13.75 20.4137 14.17 19.9937 14.6875 19.9937H26.5625C27.08 19.9937 27.5 20.4137 27.5 20.9312C27.5 21.4487 27.08 21.8687 26.5625 21.8687H14.6875C14.17 21.8687 13.75 21.4487 13.75 20.9312ZM2.5 14.6812C2.5 14.1637 2.92 13.7437 3.4375 13.7437H26.5625C27.08 13.7437 27.5 14.1637 27.5 14.6812C27.5 15.1987 27.08 15.6187 26.5625 15.6187H3.4375C2.92 15.6187 2.5 15.1987 2.5 14.6812ZM7.5 8.43124C7.5 7.91374 7.92 7.49374 8.4375 7.49374H26.5625C27.08 7.49374 27.5 7.91374 27.5 8.43124C27.5 8.94874 27.08 9.36874 26.5625 9.36874H8.4375C7.92 9.36874 7.5 8.94874 7.5 8.43124Z"
                fill="black"
              />
            </svg>
          {:else}
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.25 8.75L8.75 21.25M8.75 8.75L21.25 21.25"
                stroke="#71717A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          {/if}
        </button>
      {/if}
    </div>
  </div>

  <!-- Mobile Menu -->
  <div
    class={`lg:hidden ${menuOpen ? 'block' : 'hidden'} fixed left-0 right-0 top-[96px]   py-4 shadow-md`}
  >
    <button
      class="fixed bottom-0 left-0 right-0 top-[85px] bg-black/50"
      on:click={() => (menuOpen = false)}
    ></button>
    <nav
      class="fixed top-[85px] flex h-screen w-[80vw] max-w-[400px] flex-col items-start space-y-4 bg-[--color-neutral-white] p-8"
    >
      {#each menu.links as link}
        <a href={link.value} class="text-gray-600 hover:text-black"
          >{@html link.label}</a
        >
      {/each}
    </nav>
  </div>
</header>
